// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1NojG","title":"FrontImage_title__4lN50"};